import type { CSSProperties } from 'react';

/**
 * Single font source for reaction preview/export text (arrow labels + molecule symbols).
 * Molecule atom symbols from svg-interactive default to `PTSans-Bold`.
 */
export const REACTION_PREVIEW_FONT_FAMILY = 'PTSans-Bold';

/**
 * `font-family` for standalone `<text>` in exported SVG when @font-face may be missing.
 * Keeps metrics closer to PT Sans if the embedded WOFF failed to load on the client.
 */
export const REACTION_SVG_TEXT_FONT_FAMILY =
  'PTSans-Bold, DejaVu Sans, Liberation Sans, Helvetica Neue, Helvetica, Arial, sans-serif';

/**
 * At schemeDisplayZoom=1, render sidebar font baseline at 16 CSS px (12pt @ 96dpi).
 */
export const REACTION_LABEL_BASE_PX = 18;

/** Empty-slot headings (e.g. “Edit Reactant”) — match arrow label size and font. */
export function reactionPreviewDropTargetHeadingStyle(fontPx: number): CSSProperties {
  return {
    fontSize: `${fontPx}px`,
    fontFamily: REACTION_PREVIEW_FONT_FAMILY,
    lineHeight: 1,
    textTransform: 'none',
  };
}
